import React from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { palette } from '../../../system/styles/styles';

const ContainerMain = styled.main`
  .autocomplete-dropdown-container {
    width: 100%;
    z-index: 999;
    position: absolute;
    left: 0;
  }
  .suggestion-item {
    padding: 10px;
    font-size: 16px;
    span {
      font-size: 16px;
      transition: cubic-bezier(0.075, 0.82, 0.165, 1) 0.6s;
    }
    &:hover {
      background-color: #253858;
      //color: ${palette.white};
    }
  }

  .suggestion-item--active {
    padding: 10px;
    font-size: 16px;
    background-color: #253858;
  }
`;

class LocationSearchInput extends React.Component {
  constructor(props) {
    super(props);
    const { prefill } = this.props;
    this.state = { address: prefill || '' };
  }

  componentDidMount() {
    const { prefill } = this.props;
    this.setState({ address: prefill });
  }

  handleChange = (address) => {
    this.setState({ address });
  };

  handleSelect = async (address) => {
    try {
      const { returnLatLang } = this.props;
      const results = await geocodeByAddress(address);
      await this.setState({ address: results[0].formatted_address });
      const { address: Address } = this.state;
      const latLng = await getLatLng(results[0]);
      returnLatLang(latLng, Address);
    } catch (err) {
      console.error('Error', err);
    }
  };

  render() {
    const { address } = this.state;
    const { errors } = this.props;
    return (
      <PlacesAutocomplete value={address} onChange={this.handleChange} onSelect={this.handleSelect}>
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <ContainerMain>
            <input
              {...getInputProps({
                placeholder: 'Search Places ...',
                className: 'location-search-input',
              })}
              className={errors ? 'input_err inputSelect' : 'inputSelect'}
            />
            <div className="autocomplete-dropdown-container">
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion) => {
                const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}>
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </ContainerMain>
        )}
      </PlacesAutocomplete>
    );
  }
}

LocationSearchInput.propTypes = {
  prefill: PropTypes.string,
  defaultLabel: PropTypes.string,
  returnLatLang: PropTypes.func,
  errors: PropTypes.bool,
};

LocationSearchInput.defaultProps = {
  prefill: '',
  defaultLabel: '',
  returnLatLang: () => {},
  errors: false,
};

export default LocationSearchInput;
